import { render, staticRenderFns } from "./TestSelections.vue?vue&type=template&id=bebc3db8&scoped=true"
import script from "./TestSelections.vue?vue&type=script&lang=js"
export * from "./TestSelections.vue?vue&type=script&lang=js"
import style0 from "./TestSelections.vue?vue&type=style&index=0&id=bebc3db8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bebc3db8",
  null
  
)

export default component.exports